import { SIGNIN_USER_SUCCESS, REFRESH_TOKEN } from '../../constants/ActionTypes';

const INIT_STATE = {
  token: null,
  type: 'Bearer',
  expiresIn: null,
  expiresInMs: null,
};

export default function Auth(state = INIT_STATE, action) {
  switch (action.type) {
    case SIGNIN_USER_SUCCESS:
      return action.payload;
    case REFRESH_TOKEN:
      return { ...state, token: action.payload };
    default:
      return state;
  }
}
